// extracted by mini-css-extract-plugin
export var cardIcon = "_55-4";
export var checkboxCard = "_55-0";
export var checkboxCardSelected = "_55-3";
export var disabled = "_55-1";
export var outerBorder = "_55-2";
export var spacerMedium = "_55-7";
export var spacerSmall = "_55-6";
export var spacerXsmall = "_55-5";